import { Transport } from "../objects/transport";

export function computeTransportDuration(transport: Transport['alternatives'][number]): number {
    return transport.steps.reduce((prev, current) => {
        return prev + Math.abs(current.duration);
    }, 0);
}
